/**
 * @generated SignedSource<<d1b58898cb24ebb855fc957bbf66f88e>>
 * @relayHash 949330e07ba61fd88576d21e94f119fb
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID b4252c1739ac4fa25f521892d38c5a1592bfc3cd2fa30951ae5a38076f7d4d00

import type { ConcreteRequest } from 'relay-runtime';
export type RovoOpsComponentQuery$variables = {
  cloudIdID: string;
  cloudIdString: string;
  dynatraceDimensionIds: ReadonlyArray<string>;
  externalReference: string;
  honeycombDimensionIds: ReadonlyArray<string>;
  newRelicDimensionIds: ReadonlyArray<string>;
};
export type RovoOpsComponentQuery$data = {
  readonly agentStudio_getByExternalReference: {
    readonly id?: string;
  } | null;
  readonly agentStudio_tools: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly definitionId: string | null;
        readonly tags: ReadonlyArray<string> | null;
      } | null;
    }>;
  } | null;
  readonly rovoOpsDynatraceIntegrationItems: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id?: string;
      } | null;
    }>;
  } | null;
  readonly rovoOpsHoneycombIntegrationItems: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id?: string;
      } | null;
    }>;
  } | null;
  readonly rovoOpsNewRelicIntegrationItems: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id?: string;
      } | null;
    }>;
  } | null;
};
export type RovoOpsComponentQuery = {
  response: RovoOpsComponentQuery$data;
  variables: RovoOpsComponentQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudIdID"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudIdString"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "dynatraceDimensionIds"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "externalReference"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "honeycombDimensionIds"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "newRelicDimensionIds"
},
v6 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudIdString"
},
v7 = [
  (v6/*: any*/),
  {
    "kind": "Variable",
    "name": "externalReference",
    "variableName": "externalReference"
  }
],
v8 = {
  "kind": "ScalarField",
  "name": "id"
},
v9 = [
  (v8/*: any*/)
],
v10 = {
  "kind": "InlineFragment",
  "selections": (v9/*: any*/),
  "type": "AgentStudioAssistant"
},
v11 = [
  (v6/*: any*/),
  {
    "kind": "Literal",
    "name": "scenarioVersion",
    "value": 2
  }
],
v12 = {
  "kind": "ScalarField",
  "name": "definitionId"
},
v13 = {
  "kind": "ScalarField",
  "name": "tags"
},
v14 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudIdID"
},
v15 = {
  "kind": "Literal",
  "name": "first",
  "value": 1
},
v16 = {
  "kind": "Literal",
  "name": "relevantFor",
  "value": "MCP_SERVER"
},
v17 = [
  (v14/*: any*/),
  {
    "kind": "Variable",
    "name": "dimensionIds",
    "variableName": "newRelicDimensionIds"
  },
  (v15/*: any*/),
  (v16/*: any*/)
],
v18 = {
  "kind": "InlineFragment",
  "selections": (v9/*: any*/),
  "type": "GraphIntegrationMcpServer"
},
v19 = [
  {
    "concreteType": "GraphIntegrationDirectoryItemEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v18/*: any*/)
        ]
      }
    ]
  }
],
v20 = [
  (v14/*: any*/),
  {
    "kind": "Variable",
    "name": "dimensionIds",
    "variableName": "dynatraceDimensionIds"
  },
  (v15/*: any*/),
  (v16/*: any*/)
],
v21 = [
  (v14/*: any*/),
  {
    "kind": "Variable",
    "name": "dimensionIds",
    "variableName": "honeycombDimensionIds"
  },
  (v15/*: any*/),
  (v16/*: any*/)
],
v22 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v23 = [
  {
    "concreteType": "GraphIntegrationDirectoryItemEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v22/*: any*/),
          (v18/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": (v9/*: any*/),
            "type": "GraphIntegrationActionDirectoryItem"
          },
          {
            "kind": "InlineFragment",
            "selections": (v9/*: any*/),
            "type": "GraphIntegrationMcpTool"
          },
          {
            "kind": "InlineFragment",
            "selections": (v9/*: any*/),
            "type": "GraphIntegrationSkillDirectoryItem"
          },
          {
            "kind": "InlineFragment",
            "selections": (v9/*: any*/),
            "type": "GraphIntegrationSkillItem"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/)
    ],
    "kind": "Fragment",
    "name": "RovoOpsComponentQuery",
    "selections": [
      {
        "args": (v7/*: any*/),
        "kind": "LinkedField",
        "name": "agentStudio_getByExternalReference",
        "plural": false,
        "selections": [
          (v10/*: any*/)
        ]
      },
      {
        "args": (v11/*: any*/),
        "concreteType": "AgentStudioToolsConnection",
        "kind": "LinkedField",
        "name": "agentStudio_tools",
        "plural": false,
        "selections": [
          {
            "concreteType": "AgentStudioToolEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "concreteType": "AgentStudioTool",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v12/*: any*/),
                  (v13/*: any*/)
                ]
              }
            ]
          }
        ]
      },
      {
        "alias": "rovoOpsNewRelicIntegrationItems",
        "args": (v17/*: any*/),
        "concreteType": "GraphIntegrationDirectoryItemConnection",
        "kind": "LinkedField",
        "name": "graphIntegration_componentDirectoryItems",
        "plural": false,
        "selections": (v19/*: any*/)
      },
      {
        "alias": "rovoOpsDynatraceIntegrationItems",
        "args": (v20/*: any*/),
        "concreteType": "GraphIntegrationDirectoryItemConnection",
        "kind": "LinkedField",
        "name": "graphIntegration_componentDirectoryItems",
        "plural": false,
        "selections": (v19/*: any*/)
      },
      {
        "alias": "rovoOpsHoneycombIntegrationItems",
        "args": (v21/*: any*/),
        "concreteType": "GraphIntegrationDirectoryItemConnection",
        "kind": "LinkedField",
        "name": "graphIntegration_componentDirectoryItems",
        "plural": false,
        "selections": (v19/*: any*/)
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/),
      (v3/*: any*/),
      (v5/*: any*/),
      (v2/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Operation",
    "name": "RovoOpsComponentQuery",
    "selections": [
      {
        "args": (v7/*: any*/),
        "kind": "LinkedField",
        "name": "agentStudio_getByExternalReference",
        "plural": false,
        "selections": [
          (v22/*: any*/),
          (v10/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": (v9/*: any*/),
            "type": "Node",
            "abstractKey": "__isNode"
          }
        ]
      },
      {
        "args": (v11/*: any*/),
        "concreteType": "AgentStudioToolsConnection",
        "kind": "LinkedField",
        "name": "agentStudio_tools",
        "plural": false,
        "selections": [
          {
            "concreteType": "AgentStudioToolEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "concreteType": "AgentStudioTool",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v12/*: any*/),
                  (v13/*: any*/),
                  (v8/*: any*/)
                ]
              }
            ]
          }
        ]
      },
      {
        "alias": "rovoOpsNewRelicIntegrationItems",
        "args": (v17/*: any*/),
        "concreteType": "GraphIntegrationDirectoryItemConnection",
        "kind": "LinkedField",
        "name": "graphIntegration_componentDirectoryItems",
        "plural": false,
        "selections": (v23/*: any*/)
      },
      {
        "alias": "rovoOpsDynatraceIntegrationItems",
        "args": (v20/*: any*/),
        "concreteType": "GraphIntegrationDirectoryItemConnection",
        "kind": "LinkedField",
        "name": "graphIntegration_componentDirectoryItems",
        "plural": false,
        "selections": (v23/*: any*/)
      },
      {
        "alias": "rovoOpsHoneycombIntegrationItems",
        "args": (v21/*: any*/),
        "concreteType": "GraphIntegrationDirectoryItemConnection",
        "kind": "LinkedField",
        "name": "graphIntegration_componentDirectoryItems",
        "plural": false,
        "selections": (v23/*: any*/)
      }
    ]
  },
  "params": {
    "id": "b4252c1739ac4fa25f521892d38c5a1592bfc3cd2fa30951ae5a38076f7d4d00",
    "metadata": {},
    "name": "RovoOpsComponentQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "7ac3beefee778215fdbbe8d20c559ffd";

export default node;
